<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Hồ sơ Ban Giám Hiệu"
          :link="[
            {
              text: 'Hồ sơ',
              href: '../managerDocumentTypes'
            }
          ]"
        />
      </div>
    </div>

    <v-row>
      <v-col :cols="isLargeScreen ? 4 : 12">
        <v-card outlined class="elevation-0 px-6 ">
          <v-card-title class="px-0">
            Thư mục
          </v-card-title>
          <v-card-text class="px-0">
            <div class="d-flex align-center pb-6" v-if="isEditDocument">
              <v-btn outlined color="primary" @click.stop="orderDialog = !orderDialog" v-if="!disableDrag">
                Chỉnh thứ tự
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn depressed dark color="primary" @click.stop="dialog = true">
                Thêm mục
              </v-btn>
            </div>
            <DocumentTypeDataTable :type="'manager-document'" @openDoc="openDoc" ref="dataTable" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="isLargeScreen ? 8 : 12">
        <div style="height: 100%">
          <ManagerDocuments :documentTypeId="typeId" />
        </div>
      </v-col>
    </v-row>
    <DocumentTypeIndexDialog :state="orderDialog" @refresh="refresh" />
    <v-dialog v-model="dialog" scrollable width="700">
      <v-card>
        <v-toolbar color="primary" dense class="elevation-0" dark>
          <v-toolbar-title>Thêm mục</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form">
            <v-text-field
              v-model="title"
              :rules="[$rules.required]"
              label="Tên mục"
              class="required mt-6"
              outlined
              dense
            ></v-text-field>
            <v-textarea v-model="description" label="Mô tả" outlined></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-btn outlined @click="cancel">HUỶ</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">LƯU</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import DocumentTypeDataTable from '@/modules/document/DocumentTypeDataTable.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import ManagerDocuments from './ManagerDocuments.vue'
import DocumentTypeIndexDialog from '../../modules/document/DocumentTypeIndexDialog.vue'

export default {
  components: {
    Breadcrumbs,
    DocumentTypeDataTable,
    ManagerDocuments,
    DocumentTypeIndexDialog
  },
  data() {
    return {
      dialog: false,
      orderDialog: false,
      description: '',
      title: '',
      typeId: '',
      isLargeScreen: window.innerWidth > 1460
    }
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role', 'user', 'isEditDocument']),
    ...mapState('DocumentTypes', ['documentTypes']),
    disableDrag() {
      return this.role.type === 'teacher' || this.role.type === 'inspector'
    }
  },
  methods: {
    ...mapActions('DocumentTypes', ['createDocumentType']),
    handleResize() {
      this.isLargeScreen = window.innerWidth > 1460
    },
    cancel() {
      this.dialog = false
    },
    openDoc(item) {
      this.typeId = item.id
    },
    refresh() {
      this.$refs.dataTable.refresh()
    },
    async save() {
      if (!this.$refs.form.validate()) return
      try {
        this.$loading.active = true

        const data = {
          type: 'manager-document',
          title: this.title,
          description: this.description,
          index: this.documentTypes.length + 1
        }
        await this.createDocumentType(data)

        this.$refs.form.reset()
        this.dialog = false
        this.$alert.addSuccess()
      } catch (error) {
        this.$alert.addError()
      } finally {
        this.$loading.active = false
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped></style>
